import React from 'react';
import PropTypes from 'prop-types';
import { BaasicDraggableModalTemplate } from 'themes/components';
import { defaultTemplate } from 'core/hoc';

const BaasicDraggableModal = function(props) {
    return <BaasicDraggableModalTemplate {...props} />
};

BaasicDraggableModal.propTypes = {
    modalParams: PropTypes.object.isRequired
};

export default defaultTemplate(BaasicDraggableModal);
